export enum WorkFlow 
{
    // CHRONIC = "Chronic",
    // ACUTE = "Acute",
    CHRONIC_ACUTE="Chronic/Acute",
    HOME = "Home", 
}

